import React from 'react';

const OPTIONS = [
  { key: '1h', label: '1 Hour' },
  { key: '1d', label: '1 Day' },
  { key: '7d', label: '7 Days' },
];

/**
 * Point 43 — small duration picker shown when pinning a message. Reused
 * across CustomerChat / AdminChat / HandlerChat / GroupChatPage so the
 * "how long should this stay pinned" prompt looks the same everywhere.
 */
const PinDurationPicker = ({ onPick, onClose }) => (
  <div className="fixed inset-0 bg-black/40 z-[95] flex items-center justify-center p-4" onClick={onClose}>
    <div className="bg-white rounded-xl w-full max-w-xs p-4 shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="pin-duration-picker">
      <h4 className="text-sm font-bold text-gray-800 mb-3 text-center">Pin for how long?</h4>
      <div className="space-y-2">
        {OPTIONS.map((o) => (
          <button
            key={o.key}
            onClick={() => onPick(o.key)}
            className="w-full py-2.5 rounded-lg bg-gray-100 hover:bg-blue-50 hover:text-blue-700 font-semibold text-sm"
            data-testid={`pin-duration-${o.key}`}
          >
            {o.label}
          </button>
        ))}
      </div>
      <button onClick={onClose} className="w-full mt-3 py-2 text-xs text-gray-500 hover:text-gray-700">Cancel</button>
    </div>
  </div>
);

export default PinDurationPicker;
